import { Entity } from "@jobilla/entity";

export class Token extends Entity {
  id!: string;
  type!: "campaign" | "campaign_lite" | "campaign_pro" | "range_booster" | "duration_booster" | "contact_booster";
  orderItemId!: string;
  expiresAt!: string;
}
